import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccountPlan = /*#__PURE__*/function (AccountPlan) {
  AccountPlan[AccountPlan["ACCOUNT_PLAN_INVALID"] = 0] = "ACCOUNT_PLAN_INVALID";
  AccountPlan[AccountPlan["ACCOUNT_PLAN_EMAIL"] = 1] = "ACCOUNT_PLAN_EMAIL";
  AccountPlan[AccountPlan["ACCOUNT_PLAN_EMAIL_PLUS"] = 2] = "ACCOUNT_PLAN_EMAIL_PLUS";
  AccountPlan[AccountPlan["ACCOUNT_PLAN_LITE"] = 3] = "ACCOUNT_PLAN_LITE";
  AccountPlan[AccountPlan["ACCOUNT_PLAN_STANDARD"] = 4] = "ACCOUNT_PLAN_STANDARD";
  AccountPlan[AccountPlan["ACCOUNT_PLAN_PREMIUM"] = 5] = "ACCOUNT_PLAN_PREMIUM";
  return AccountPlan;
}(AccountPlan || {});
var AccountStatus = /*#__PURE__*/function (AccountStatus) {
  AccountStatus[AccountStatus["ACCOUNT_STATUS_INVALID"] = 0] = "ACCOUNT_STATUS_INVALID";
  AccountStatus[AccountStatus["ACCOUNT_STATUS_TRIAL"] = 1] = "ACCOUNT_STATUS_TRIAL";
  AccountStatus[AccountStatus["ACCOUNT_STATUS_OPEN"] = 2] = "ACCOUNT_STATUS_OPEN";
  AccountStatus[AccountStatus["ACCOUNT_STATUS_CANCELLED"] = 3] = "ACCOUNT_STATUS_CANCELLED";
  AccountStatus[AccountStatus["ACCOUNT_STATUS_PENDING_CANCELLATION"] = 4] = "ACCOUNT_STATUS_PENDING_CANCELLATION";
  AccountStatus[AccountStatus["ACCOUNT_STATUS_TRIAL_END"] = 5] = "ACCOUNT_STATUS_TRIAL_END";
  return AccountStatus;
}(AccountStatus || {});
// *********************************

function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Account {
  static fromProto(proto) {
    let m = new Account();
    m = Object.assign(m, proto);
    if (proto.pricingTierId) {
      m.pricingTierId = parseInt(proto.pricingTierId, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue(AccountStatus, proto.status);
    }
    if (proto.plan) {
      m.plan = enumStringToValue(AccountPlan, proto.plan);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.pricingTierId !== 'undefined') {
      toReturn['pricingTierId'] = this.pricingTierId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.plan !== 'undefined') {
      toReturn['plan'] = this.plan;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetMultiCampaignsResponseCampaign {
  static fromProto(proto) {
    let m = new GetMultiCampaignsResponseCampaign();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.campaignName !== 'undefined') {
      toReturn['campaignName'] = this.campaignName;
    }
    return toReturn;
  }
}
class GetAccountRequest {
  static fromProto(proto) {
    let m = new GetAccountRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetAccountResponse {
  static fromProto(proto) {
    let m = new GetAccountResponse();
    m = Object.assign(m, proto);
    if (proto.account) {
      m.account = Account.fromProto(proto.account);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.account !== 'undefined' && this.account !== null) {
      toReturn['account'] = 'toApiJson' in this.account ? this.account.toApiJson() : this.account;
    }
    return toReturn;
  }
}
class GetMultiCampaignsRequest {
  static fromProto(proto) {
    let m = new GetMultiCampaignsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.campaignIds !== 'undefined') {
      toReturn['campaignIds'] = this.campaignIds;
    }
    return toReturn;
  }
}
class GetMultiCampaignsResponse {
  static fromProto(proto) {
    let m = new GetMultiCampaignsResponse();
    m = Object.assign(m, proto);
    if (proto.campaigns) {
      m.campaigns = proto.campaigns.map(GetMultiCampaignsResponseCampaign.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaigns !== 'undefined' && this.campaigns !== null) {
      toReturn['campaigns'] = 'toApiJson' in this.campaigns ? this.campaigns.toApiJson() : this.campaigns;
    }
    return toReturn;
  }
}
class ListAccountsRequest {
  static fromProto(proto) {
    let m = new ListAccountsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAccountsResponse {
  static fromProto(proto) {
    let m = new ListAccountsResponse();
    m = Object.assign(m, proto);
    if (proto.accounts) {
      m.accounts = proto.accounts.map(Account.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accounts !== 'undefined' && this.accounts !== null) {
      toReturn['accounts'] = 'toApiJson' in this.accounts ? this.accounts.toApiJson() : this.accounts;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListPricingTiersRequest {
  static fromProto(proto) {
    let m = new ListPricingTiersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListPricingTiersResponse {
  static fromProto(proto) {
    let m = new ListPricingTiersResponse();
    m = Object.assign(m, proto);
    if (proto.pricingTiers) {
      m.pricingTiers = proto.pricingTiers.map(ListPricingTiersResponsePricingTier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pricingTiers !== 'undefined' && this.pricingTiers !== null) {
      toReturn['pricingTiers'] = 'toApiJson' in this.pricingTiers ? this.pricingTiers.toApiJson() : this.pricingTiers;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListPricingTiersResponsePricingTier {
  static fromProto(proto) {
    let m = new ListPricingTiersResponsePricingTier();
    m = Object.assign(m, proto);
    if (proto.id) {
      m.id = parseInt(proto.id, 10);
    }
    if (proto.minContact) {
      m.minContact = parseInt(proto.minContact, 10);
    }
    if (proto.maxContact) {
      m.maxContact = parseInt(proto.maxContact, 10);
    }
    if (proto.wholesalePriceInCents) {
      m.wholesalePriceInCents = parseInt(proto.wholesalePriceInCents, 10);
    }
    if (proto.retailPriceInCents) {
      m.retailPriceInCents = parseInt(proto.retailPriceInCents, 10);
    }
    if (proto.plan) {
      m.plan = enumStringToValue(AccountPlan, proto.plan);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.minContact !== 'undefined') {
      toReturn['minContact'] = this.minContact;
    }
    if (typeof this.maxContact !== 'undefined') {
      toReturn['maxContact'] = this.maxContact;
    }
    if (typeof this.contactRangeDisplayString !== 'undefined') {
      toReturn['contactRangeDisplayString'] = this.contactRangeDisplayString;
    }
    if (typeof this.wholesalePriceInCents !== 'undefined') {
      toReturn['wholesalePriceInCents'] = this.wholesalePriceInCents;
    }
    if (typeof this.retailPriceInCents !== 'undefined') {
      toReturn['retailPriceInCents'] = this.retailPriceInCents;
    }
    if (typeof this.plan !== 'undefined') {
      toReturn['plan'] = this.plan;
    }
    return toReturn;
  }
}
class UpdateAccountPlanRequest {
  static fromProto(proto) {
    let m = new UpdateAccountPlanRequest();
    m = Object.assign(m, proto);
    if (proto.plan) {
      m.plan = enumStringToValue(AccountPlan, proto.plan);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.plan !== 'undefined') {
      toReturn['plan'] = this.plan;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'constant-contact-api.vendasta-local.com',
  'test': '',
  'demo': 'constant-contact-api-demo.apigateway.co',
  'prod': 'constant-contact-api-prod.apigateway.co',
  'production': 'constant-contact-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AccountApiService = /*#__PURE__*/(() => {
  class AccountApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listPricingTiers(r) {
      const request = r.toApiJson ? r : new ListPricingTiersRequest(r);
      return this.http.post(this._host + "/constantcontact.v1.AccountService/ListPricingTiers", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPricingTiersResponse.fromProto(resp)));
    }
    listAccounts(r) {
      const request = r.toApiJson ? r : new ListAccountsRequest(r);
      return this.http.post(this._host + "/constantcontact.v1.AccountService/ListAccounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAccountsResponse.fromProto(resp)));
    }
    getAccount(r) {
      const request = r.toApiJson ? r : new GetAccountRequest(r);
      return this.http.post(this._host + "/constantcontact.v1.AccountService/GetAccount", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountResponse.fromProto(resp)));
    }
    updateAccountPlan(r) {
      const request = r.toApiJson ? r : new UpdateAccountPlanRequest(r);
      return this.http.post(this._host + "/constantcontact.v1.AccountService/UpdateAccountPlan", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AccountApiService.ɵfac = function AccountApiService_Factory(t) {
    return new (t || AccountApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountApiService,
    factory: AccountApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccountService = /*#__PURE__*/(() => {
  class AccountService {
    constructor(accountApiService) {
      this.accountApiService = accountApiService;
    }
    listPricingTiers(partnerId) {
      return this.accountApiService.listPricingTiers(new ListPricingTiersRequest({
        partnerId: partnerId
      })).pipe(map(resp => {
        return resp.pricingTiers;
      }));
    }
    listAccounts(partnerId, cursor, pageSize) {
      return this.accountApiService.listAccounts(new ListAccountsRequest({
        partnerId: partnerId,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }));
    }
    getAccount(businessId) {
      return this.accountApiService.getAccount(new GetAccountRequest({
        businessId: businessId
      })).pipe(map(resp => {
        return resp.account;
      }));
    }
    updateAccountPlan(partnerId, businessId, plan) {
      return this.accountApiService.updateAccountPlan(new UpdateAccountPlanRequest({
        partnerId: partnerId,
        businessId: businessId,
        plan: plan
      })).pipe(map(() => true));
    }
  }
  AccountService.ɵfac = function AccountService_Factory(t) {
    return new (t || AccountService)(i0.ɵɵinject(AccountApiService));
  };
  AccountService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountService,
    factory: AccountService.ɵfac,
    providedIn: 'root'
  });
  return AccountService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CampaignApiService = /*#__PURE__*/(() => {
  class CampaignApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiCampaignsRequest(r);
      return this.http.post(this._host + "/constantcontact.v1.CampaignService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCampaignsResponse.fromProto(resp)));
    }
  }
  CampaignApiService.ɵfac = function CampaignApiService_Factory(t) {
    return new (t || CampaignApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CampaignApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignApiService,
    factory: CampaignApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CampaignService = /*#__PURE__*/(() => {
  class CampaignService {
    constructor(campaignApiService) {
      this.campaignApiService = campaignApiService;
    }
    getMulti(partnerId, businessId, campaignIds) {
      return this.campaignApiService.getMulti(new GetMultiCampaignsRequest({
        partnerId: partnerId,
        businessId: businessId,
        campaignIds: campaignIds
      })).pipe(map(resp => {
        return resp.campaigns;
      }));
    }
  }
  CampaignService.ɵfac = function CampaignService_Factory(t) {
    return new (t || CampaignService)(i0.ɵɵinject(CampaignApiService));
  };
  CampaignService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignService,
    factory: CampaignService.ɵfac,
    providedIn: 'root'
  });
  return CampaignService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Account, AccountApiService, AccountPlan, AccountService, AccountStatus, CampaignApiService, CampaignService, GetAccountRequest, GetAccountResponse, GetMultiCampaignsRequest, GetMultiCampaignsResponse, GetMultiCampaignsResponseCampaign, HostService, ListAccountsRequest, ListAccountsResponse, ListPricingTiersRequest, ListPricingTiersResponse, ListPricingTiersResponsePricingTier, PagedRequestOptions, PagedResponseMetadata, UpdateAccountPlanRequest };
